import { DatenauswertungGenerisch } from '../datenauswertung/DatenauswertungGenerisch';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { formatNumber } from '../../core/formatter/formatNumber';
import { getStyle } from '../datenauswertung/generisch/DatanauswertungGenerischStyles';
import { IDs } from '../../helpers/IDs';
import { isValid } from '../../main/functions/validData';
import * as Moment from 'moment';
import * as React from 'react';

interface ZusatzToolsZertifizierungTabelle2Props extends React.ClassAttributes<any> {
    data: any;
}

interface ZusatzToolsZertifizierungTabelle2State {
    pdfString?: string;
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
}

export class ZusatzToolsZertifizierungTabelle2 extends
    React.Component<ZusatzToolsZertifizierungTabelle2Props, ZusatzToolsZertifizierungTabelle2State> {

    constructor(props: any) {
        super(props);
        const konfig = props.data[IDs.ENT_KONFIGURATION];
        const jahrMax = Moment().year() - 1;
        let jahrMin = 2010;

        if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
            jahrMin = konfig[0].startjahr_datenerfassung;
        }
        this.state = {
            jahr: jahrMax,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined
        };
    }

    getValues(): any {
        const data: any = this.props.data || {};
        const diag1: any[] = [];
        const diag2: any[] = [];
        const jahr = this.state.jahr;
        const maschinen: any[] = data[IDs.ENT_MASCHINEN] || [];
        // const maschinen_jahreswerte: any[] = data[IDs.ENT_MASCHINEN_JAHRESWERTE] || [];
        const rows: any[] = [];
        let cnt = 0;
        // console.log('M', maschinen, maschinen_jahreswerte);
        maschinen.forEach((maschine: any) => {
            if (!isValid(maschine, IDs.ENT_MASCHINEN) || (+maschine.status || null) === 2) {
                return;
            }
            cnt++;
            const alter = maschine.baujahr && maschine.baujahr > 0 ? jahr - maschine.baujahr : -1;
            const energietraeger = maschine.energiedaten_waerme_energietraeger_tid;
            const abwaerme = maschine.abwaerme;
            const leistung = maschine.leistung;
            const werte = maschine || {};
            // const werte = maschinen_jahreswerte.find((mjw: any) => mjw.maschinen_tid_orig === maschine.tid && jahr === mjw.jahr)
            //     || maschine || {};
            const verbrauch = Object.keys(werte).length
                ? (werte.auslastungsfaktor / 100) * werte.betriebszeit_h_tag * werte.betriebszeit_tage_jahr * leistung
                : 0;
            // console.log('W: ', werte);
            const row = [
                cnt,
                maschine.name,
                alter < 0 ? '-' : alter === 0 ? '< 1 Jahr' : alter === 1 ? '1 Jahr' : `${alter} Jahre`,
                leistung > 0 ? `${formatNumber(leistung, 2)} kW` : '-',
                energietraeger,
                verbrauch && verbrauch > 0 ? `${formatNumber(verbrauch, 2)} kWh` : '-',
                abwaerme > 0 ? `${abwaerme}°` : '-',
                maschine.messsystem,
                maschine.kalibrierung
            ];
            rows.push(row);
        });
        return { rows, diag1, diag2 };
    }

    render(): JSX.Element {
        const lineColor = ['#4f81bd', '#f79646', '#87bd51', '#51bd75', '#5163bd', '#9951bd', '#bd5175', '#bd5151'];
        const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        const numCols = 9;
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const values = this.getValues();
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const config: any = {
            titel0: unternehmen,
            titel1: 'Nachweis Alternatives System',
            titel3: 'Tabelle 2 - Erfassung und Analyse von Energieverbrauchern',
            filename: 'Alternatives_System_Energieverbraucher.pdf',
            baseWidth: baseWidth,
            header: {
                blocks: [
                    {
                        label: 'Energieverbraucher',
                        width: `${baseWidth * 4}%`,
                        columns: [
                            { label: 'Nr', label2: ' ', customStyleLabel: { fontSize: 8 }, customStyleColumn: { paddingRight: 1 } },
                            { label: 'Anlage / Teil', label2: ' ' },
                            { label: 'Alter', label2: ' ' },
                            { label: 'Kapazität', label2: ' ' }
                        ]
                    },
                    {
                        label: 'Eingesetzte Energie',
                        width: `${baseWidth * 2}%`,
                        columns: [
                            { label: 'Energieträger', label2: ' ' },
                            { label: 'Energie', label2: 'kWh' }
                        ]
                    },
                    {
                    label: 'Abwärme\n(Temperaturniveau)',
                        width: `${baseWidth}%`
                    },
                    {
                        label: 'Messsystem /\nMessart',
                        width: `${baseWidth}%`
                    },
                    {
                        label: 'Genauigkeit /\nKalibrierung',
                        width: `${baseWidth}%`
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header'],
            diagrams: []
        };

        return (
            <>
                <div
                    style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#eee', paddingLeft: 25, position: 'sticky', top: 0 }}
                >
                    {this.renderJahresauswahl()}
                </div>
                <div style={{ margin: 10 }}>
                    <div style={{ fontSize: '10pt', paddingLeft: 20 }}>
                        <b>Hinweis:</b> Diese Daten wurden automatisch aus der Dateneingabe generiert.
                    </div>
                    <DatenauswertungGenerisch
                        config={config}
                        orientation='landscape'
                        setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    />
                </div>
            </>
        );
    }

    renderJahresauswahl(): JSX.Element {
        return (
            <div style={{ width: '100%', maxWidth: 1367, boxSizing: 'border-box' }}>
                <DatenauswertungJahrauswahlEinzeln
                    jahrMax={this.state.jahrMax}
                    jahrMin={this.state.jahrMin}
                    jahr={this.state.jahr}
                    externalHeaderElements={[<div style={{ margin: 'auto 0 auto auto' }}>{this.state.renderButton}</div>]}
                    onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                />
            </div>
        );
    }
}
